import React, { Component } from 'react';
import { observer } from 'mobx-react';
import 'Styles/MkMessaging/messageList.scss';
import MkMessageListStore from 'Stores/mkMessaging/mkMessageListStore';
import AppStore from 'Stores/AppStore';
import SmrTable from "Components/Common/SmrTable";
import Checkbox from "../Common/checkbox";
import { Link } from "react-router-dom";
import { GetDateFromString, ShowModal } from 'Utils/CommonFunctions';
import Helper from 'Utils/Helper';

class MkMessageList extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        AppStore.OnMainComponentMount('Информирование пользователей', 'mkMessageList', this.reloadData);

        this.props.resetNavigateFromMessageDetails();
    }

    reloadData() {
        MkMessageListStore.GetMessages(null);
    }

    renderTableLine(data) {
        let selected = MkMessageListStore.selectedMessages.indexOf(data.id) >= 0;

        return (
            <div className={`mk-message-list-table-line smr-table-line ${selected ? 'selected' : ''}`}
                key={data.id}>
                <div className='mk-message-list-table-line-checkbox-column'>
                    <Checkbox checked={selected}
                        onChange={(state) => MkMessageListStore.SelectItemInMessageList(data.id, state)} />
                </div>
                <div className='mk-message-list-table-line-id-column'>
                    {data.id}
                </div>
                <div className='mk-message-list-table-line-title-column'>
                    {data.title}
                </div>
                <div className='mk-message-list-table-line-registration-date-column'>
                    {Helper.ToUserFrendlyDateOnlyString(GetDateFromString(data.registrationDate))}
                </div>
                <div className='mk-message-list-table-line-view-count-column'>
                    {`${data.viewCount} из ${data.allCount}`}
                </div>
                <div className='mk-message-list-table-line-button-column'>
                    <Link to={`../viewMessage?messageId=${data.id}`}>
                        <button>
                            Подробнее
                        </button>
                    </Link>
                </div>
            </div>
        )
    }

    renderHeader() {
        return (
            <div className='mk-message-list-table-line header'>
                <div className='mk-message-list-table-line-checkbox-column'>
                    <Checkbox checked={MkMessageListStore.allMessagesOnPageAreSelected}
                        onChange={MkMessageListStore.SelectCurrentPageOfMessages} />
                </div>
                <div className='mk-message-list-table-line-id-column'>
                    Id
                </div>
                <div className='mk-message-list-table-line-title-column'>
                    Тема сообщения
                </div>
                <div className='mk-message-list-table-line-registration-date-column'>
                    Дата создания
                </div>
                <div className='mk-message-list-table-line-view-count-column'>
                    Ознакомилось
                </div>
                <div className='mk-message-list-table-line-button-column'>
                </div>
            </div>
        )
    }

    ShowRemoveSelectedMessagesModal() {
        let modalTitle = 'Удаление выбранного сообщения';
        let modalBody = 'Внимание! Данное сообщение будет безвозвратно удалено. Пользователи, не получившие сообщение, не смогут с ним ознакомиться. Вы действительно хотите удалить данное сообщение?';

        if (MkMessageListStore.selectedMessages.length > 1) {
            modalTitle = 'Удаление выбранных сообщений';
            modalBody = 'Внимание! Выбранные сообщения будут безвозвратно удалены. Пользователи, не получившие сообщения, не смогут с ними ознакомиться. Вы действительно хотите удалить выбранные сообщения?';
        }

        ShowModal({
            canBeClosed: true,
            header: modalTitle,
            children: modalBody,
            height: 'auto',
            className: 'mk-messaging-remove-selected-modal',
            buttons: [{
                content: 'Отменить',
                closer: true
            }, {
                content: 'Удалить',
                closer: true,
                className: 'blue-button',
                onClick: MkMessageListStore.RemoveSelectedMessages.bind(MkMessageListStore)
            }]
        });
    }

    render() {
        return (
            <div className='mk-messaging-message-list-container'>
                <SmrTable className="mk-message-list"
                    loading={MkMessageListStore.messagesLoading}
                    renderTableLine={this.renderTableLine.bind(this)}
                    renderHeader={this.renderHeader.bind(this)}
                    getDataPage={MkMessageListStore.GetMessages.bind(MkMessageListStore)}
                    location={this.props.location}
                    setTableStore={MkMessageListStore.SetTableStore.bind(MkMessageListStore)}
                    buttonsPanel={{
                        right: <Link to='../newMessage'>
                            <button className={`add-message-button ${MkMessageListStore.messagesLoading ? 'disabled' : ''}`}>
                                Добавить сообщение
                            </button>
                        </Link>,
                        left: <button className={`remove-messages-button ${(MkMessageListStore.selectedMessages.length > 0 && !MkMessageListStore.messagesLoading) ? '' : 'disabled'}`}
                            onClick={this.ShowRemoveSelectedMessagesModal.bind(this)}>
                            Удалить
                        </button>
                    }} />
            </div>
        );
    }
}

export default observer(MkMessageList);